(function () {
  if (window.__nestPdpVariantKeyboardFocus20260723) return;
  window.__nestPdpVariantKeyboardFocus20260723 = 'v2-label-in-name';

  var pendingSelection = null;
  var focusSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  function cleanText(value) {
    return (value || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function isVisible(element) {
    if (!element || !element.getClientRects || !element.getClientRects().length) return false;
    var style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  }

  function isFocusable(element) {
    if (!element || element.disabled || element.getAttribute('aria-hidden') === 'true') return false;
    if (element.getAttribute('tabindex') === '-1') return false;
    return isVisible(element);
  }

  function optionLabelForSelect(select) {
    if (!select) return '';
    var selected = select.options && select.options[select.selectedIndex];
    return cleanText(selected && selected.textContent);
  }

  function syncStyledSelectLabel(styledSelect) {
    if (!styledSelect || !styledSelect.closest) return;

    var wrapper = styledSelect.closest('.select') || styledSelect.parentElement;
    var nativeSelect = wrapper && wrapper.querySelector('select.product-detail-option-select, select');
    var visibleText = cleanText(styledSelect.textContent) || optionLabelForSelect(nativeSelect);
    var selectName = cleanText(nativeSelect && (nativeSelect.getAttribute('aria-label') || nativeSelect.getAttribute('name')));
    var optionContext = selectName && /color/i.test(selectName) ? 'Color' : 'Size';

    if (!visibleText) return;
    styledSelect.setAttribute('aria-label', optionContext + ': ' + visibleText);
  }

  function syncStyledSelectLabels(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('.product-detail-description-right .styledSelect[aria-haspopup="listbox"], .product-detail-description-right .styledSelect[role="button"]'), syncStyledSelectLabel);
  }

  function customOptionFromTarget(target) {
    if (!target || !target.closest) return null;
    var option = target.closest('.product-detail-description-right .options li, .product-detail-description-right li.option-flex');
    if (!option) return null;
    var root = option.closest('.product-detail-description-right');
    var options = option.closest('.options');
    if (!root || !options) return null;
    var selectWrapper = options.closest('.select') || options.parentElement;
    if (!selectWrapper || !root.contains(selectWrapper)) return null;
    if (!selectWrapper.querySelector('select.product-detail-option-select')) return null;
    return option;
  }

  function selectionContext(option) {
    var root = option && option.closest('.product-detail-description-right');
    var options = option && option.closest('.options');
    var wrapper = options && (options.closest('.select') || options.parentElement);
    return root && wrapper ? { root: root, wrapper: wrapper, option: option } : null;
  }

  function nextControl(ctx) {
    if (!ctx || !ctx.root || !ctx.wrapper) return null;
    var controls = Array.prototype.slice.call(ctx.root.querySelectorAll(focusSelector)).filter(function (control) {
      if (!isFocusable(control)) return false;
      if (ctx.wrapper.contains(control)) return false;
      if (control.matches && control.matches('select.product-detail-option-select')) return false;
      return !!(ctx.wrapper.compareDocumentPosition(control) & Node.DOCUMENT_POSITION_FOLLOWING);
    });
    return controls[0] || null;
  }

  function focusControl(control) {
    if (!control || !control.focus) return false;
    try {
      control.focus({ preventScroll: true });
    } catch (error) {
      control.focus();
    }
    return document.activeElement === control;
  }

  function restoreNextFocus(reason) {
    var ctx = pendingSelection;
    if (!ctx) return;
    var current = document.activeElement;
    var shouldMove = !current || current === document.body || current === document.documentElement || ctx.wrapper.contains(current) || current === ctx.option;
    var control = nextControl(ctx);

    syncStyledSelectLabels(ctx.root);

    window.__nestPdpVariantKeyboardFocusLast = {
      at: Date.now(),
      reason: reason,
      selectedText: cleanText(ctx.option && (ctx.option.innerText || ctx.option.textContent)),
      activeBefore: current && current.tagName,
      nextTag: control && control.tagName,
      nextText: cleanText(control && (control.innerText || control.textContent || control.getAttribute('aria-label') || control.getAttribute('name') || '')).slice(0, 120)
    };

    if (shouldMove && control) focusControl(control);
  }

  function scheduleFocus(ctx, reason) {
    pendingSelection = ctx;
    [0, 60, 180, 400].forEach(function (delay) {
      window.setTimeout(function () { restoreNextFocus(reason + ' +' + delay); }, delay);
    });
    window.setTimeout(function () {
      if (pendingSelection === ctx) pendingSelection = null;
    }, 900);
  }

  document.addEventListener('change', function (event) {
    if (!event.target || !event.target.matches || !event.target.matches('.product-detail-option-select')) return;
    var wrapper = event.target.closest('.select') || event.target.parentElement;
    syncStyledSelectLabels(wrapper || document);
  }, true);

  document.addEventListener('click', function (event) {
    var option = customOptionFromTarget(event.target);
    if (!option) return;
    var ctx = selectionContext(option);
    window.setTimeout(function () { syncStyledSelectLabels(ctx && ctx.root); }, 0);
    window.setTimeout(function () { syncStyledSelectLabels(ctx && ctx.root); }, 120);
  }, true);

  document.addEventListener('keydown', function (event) {
    var key = event.key;
    if (key !== 'Enter' && key !== ' ' && key !== 'Spacebar') return;

    var option = customOptionFromTarget(event.target);
    var ctx = selectionContext(option);
    if (!ctx) return;

    if (key === ' ' || key === 'Spacebar') {
      event.preventDefault();
      if (option.click) option.click();
    }

    scheduleFocus(ctx, 'keyboard variant option ' + key);
  }, true);

  if (window.MutationObserver && document.documentElement) {
    new MutationObserver(function () {
      window.clearTimeout(window.__nestPdpVariantLabelTimer);
      window.__nestPdpVariantLabelTimer = window.setTimeout(syncStyledSelectLabels, 40);
    }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  }

  syncStyledSelectLabels();
  [50, 150, 400, 900, 1600, 3000].forEach(function (delay) {
    window.setTimeout(syncStyledSelectLabels, delay);
  });
})();
